// src/utils/ageTier.js
//
// Derives the content gate (`ageTier`) from a raw age. One of the three
// orthogonal axes of the member funnel (see docs/eri-hub-member-funnel-spec.md
// §1). Returns null for unparseable input so callers can defer the gate.

export const ageTier = (age) => {
  const a = parseInt(age, 10);
  if (isNaN(a)) return null;
  // 2026-10-06: the kid line moved from 16 to 13. A 14-year-old is not a
  // Kidz Corner audience. Consent, youth crisis lines and the youth check-in
  // all key off "under 18" and are unaffected.
  if (a < 13) return 'kid';   // under 13: Kidz Corner in a family org
  if (a < 18) return 'teen';  // 13–17: Teen Hub in a family org; consent required
  return 'adult';             // 18+, full self-serve
};

// Effective content gate for a user doc: prefer the stored `ageTier` field, else
// derive it from the raw `age`. Keeps legacy / existing-account docs (which may
// carry `age` but no `ageTier`) correctly gated. Returns null when neither is known.
export const resolveAgeTier = (user) =>
  (user && user.ageTier) || ageTier(user && user.age) || null;
